<template>
<div class="bg-content">
 <v-container id="home-content" >


        <v-layout row wrap>
      <v-flex lg3 xs12 ma-0>

      </v-flex>
      <v-flex lg6 xs12 ma-0 style="height: 100vh;">
<!--               <v-card my-3>
                <v-img
                  src="../images/news/postcard-hny-2019.jpg"
                >
                </v-img>

              </v-card> -->
        <v-card color="blue lighten-5 my-3">
          <v-card-text class="px-4" >
          <h4 class="display-1 text-xs-center"> 404 - ошибка.</h4>
          <p> Это означает, что мы не нашли страничку по этому адресу.</p>
          <p> Но ничего страшного. Все нужные ресурсы остались на сайте. </p>
          <p> Достаточно начать с <router-link to="/">"Главной"</router-link> странички.</p>
            </v-card-text>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > Или сразу перейти в нужные разделы  - <router-link to="print">"Для полиграфии"</router-link> и <router-link to="web">"Для WEB"</router-link> </v-list-tile-title>
            </v-list-tile-content>


          </v-list-tile>
        </v-list>

<!--         <v-divider></v-divider>

        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="pink">star</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title > В редакторе доступно 2 раздела с библиотеками изображений.  </v-list-tile-title>
            <v-list-tile-sub-title>"Фоны" - для создания подложки и "Элементы" - объекты, которые вы можете расположить на холсте</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list> -->


</v-card>

      </v-flex>
      <v-flex  lg3 xs12 ma-0>

      </v-flex>


    </v-layout>


<!--   <HelloWorld /> -->

</v-container>
</div>
</template>

<script>

import axios from "axios";
import { mapState } from "vuex";
import router from "../router";

export default {
  name: "page404",
    metaInfo: {
      title: '404 - страничка не найдена. Cardolini.',
      // override the parent template and just use the above title only
      titleTemplate: null
    },  
  components: {
    // HelloWorld,
    // ScreenSaver
  },
  computed: {
    libBGTest() {
      return this.$store.state.libBGTest;
    },
  },

  mounted() {
    console.log("monted Editor");

    this.$store.commit("titleHead", "404 - страничка не найдена");
    /* console.log("name Item =", this.$route.params.nameItem); */
    this.$nextTick(
      function() {

console.log("name Item =", this.$route.params.nameItem); 

      })
  },

}

</script>
<style>
.bg-content{
  
  background: url(/images/bgbody/bg-ny-home.jpg) no-repeat top center;
  background-size: auto;
  background-attachment: fixed;
}
</style>
